/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import ListMenu from '@salesforce/retail-react-app/app/theme/components/project/list-menu'

ListMenu.baseStyle = {
    ...ListMenu.baseStyle,
    popoverContainer: {
        background: 'gray.300',
        minHeight: '350px',
        maxWidth: '90vw',
        padding: '2rem 0'
    },
    popoverContent: {
        ...ListMenu.baseStyle.popoverContent,
        background: 'gray.300',
        minHeight: '350px',
        marginTop: '60px'
    },
    listMenuTriggerLink: {
        ...ListMenu.baseStyle.listMenuTriggerLink,
        color: 'black.100',
        marginRight: 3,
        fontWeight: '300',
        fontSize: '14px',
        paddingTop: 1,
        marginLeft: '0px',
        _hover: {
            textDecoration: 'none',
            _after: {
                width: '100%',
                backgroundColor: 'gray.900'
            }
        },
        _after: {
            content: "''",
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '0',
            height: '1px',
            backgroundColor: 'black.100',
            transition: 'width 0.3s ease-in-out'
        }
    },
    listMenuTriggerIcon: {
        variant: 'unstyled',
        position: 'absolute',
        zIndex: '-1',
        opacity: '0',
        padding: '0',
        minWidth: '0',
        bottom: '-4px',
        right: '15px',
        left: '0',
        width: '24px',
        height: '24px',
        margin: 'auto',
        _focus: {
            zIndex: 1,
            opacity: 1,
            background: 'white'
        }
    },
    popoverBody: {
        ...ListMenu.baseStyle.popoverBody,
        paddingTop: '0'
    }
}

// Remove unused properties
delete ListMenu.baseStyle.listMenuTriggerLinkActive?._before
delete ListMenu.baseStyle.listMenuTriggerlessLinkActive?._before

export default ListMenu
